import { Badge, CopyButton } from "@productlane/ui"

function Row({ label, value }: { label: string; value: string }) {
	return (
		<div className="flex items-center">
			<div className="w-1/3 shrink-0 text-sm text-secondary">{label}</div>
			<div className="flex w-2/3 min-w-0 items-center gap-2">
				<div className="truncate font-mono text-sm">{value}</div>
				<CopyButton
					value={value}
					className="!text-tertiary hover:!text-primary"
				/>
			</div>
		</div>
	)
}

export function DnsRecordBlock({
	type,
	recordKey,
	value,
	isActive,
}: {
	type: "TXT" | "CNAME"
	recordKey: string
	value: string
	isActive: boolean
}) {
	return (
		<div className="mb-4 space-y-2 rounded-lg bg-gray-100 p-3 pr-6 dark:bg-gray-800">
			<div className="flex items-center">
				<div className="w-1/3 text-sm text-secondary">Type</div>
				<div className="flex w-2/3 items-center gap-2">
					<div className="font-mono">{type}</div>
					{isActive ? (
						<Badge variant="green">Active</Badge>
					) : (
						<Badge variant="default">Pending</Badge>
					)}
				</div>
			</div>
			<Row label="Key" value={recordKey} />
			<Row label="Value" value={value} />
		</div>
	)
}
